module.exports = __webpack_public_path__ + "img/Logotipo-GeoVoy.71584f60.png";